<template>
  <b-container fluid>
    <h1 class="display-title">Calendario</h1>
    <b-row class="primer-fila">
      <b-col lg="12">
        <full-calendar :events="events" :config="config" ref="calendar"  @day-click="dayClick" @event-selected="eventClick" ></full-calendar>
      </b-col>
    </b-row>
    <!--Modal nuevo Feriado-->
    <b-modal id="modalNuevoEvento" ref="modalNuevoEvento" size="md" title="Agregar Evento" ok-title="Guardar" ok-variant="primary" @ok="crearNuevoDetalle" @shown="limpiarCamposFormulario" cancel-title="Cancelar" header-bg-variant="dark" header-text-variant="light">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
          <b-form>
            <b-form-row>
              <b-col cols="12">
                <b-form-group id="grupoDescripcion" label="Descripcion:" label-for="exampleInput2">
                  <b-form-input id="txtDetalleDescripcion" type="text"  v-model="txtDetalleDescripcion"></b-form-input>
                </b-form-group>
                <label class="typo__label" for="estados">Tipo de evento:</label>
                <multiselect id="tipoFeriado" v-model="selected" :options="opciones"  placeholder="--Seleccionar--" label="Text" track-by="Id"
                :searchable="true">
                <span slot="noResult">Oops! No se encontraron resultados.</span>
                </multiselect>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <!--Modal editar evento-->
    <b-modal id="modalEdicion" ref="modalEdicion" size="md" title="Actualizar o eliminar evento" ok-title="Guardar" ok-variant="primary"  cancel-title="Cancelar" header-bg-variant="dark" header-text-variant="light">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
          <b-form>
            <b-form-row>
              <b-col cols="12">
                <b-form-group id="exampleInputGroup2" label="Descripción:" label-for="exampleInput2">
                  <b-form-input id="exampleInput2" type="text"  v-model="txtDetalleDescripcion"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <label class="typo__label" for="estados">Tipo de evento:</label>
                <multiselect id="tipoFeriado" v-model="selected" :options="opciones"  placeholder="--Seleccionar--" label="Text" track-by="Id"
                :searchable="true">
                <span slot="noResult">Oops! No se encontraron resultados.</span>
                </multiselect>
              </b-col>
              <b-col cols="12">
                <b-form-group id="grupoFecha" label="Fecha:" label-for="detalleFecha">
                  <b-form-input id="detalleFecha" type="date"  v-model="txtDetalleFecha" readonly></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm"  variant="primary" @click="removerDetalle">
          Remover
        </b-btn>
          <b-btn size="sm" class="float-right"  variant="primary" @click="actualizarDetalle">
            Actualizar
          </b-btn>

        </div>
    </b-modal>
  </b-container>

</template>
<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import 'fullcalendar/dist/locale/es'
import CalendarioSvc from '@/services/calendario'
import DetalleCalendarioSvc from '@/services/detallecalendarioferiado'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
export default{
  name: 'Eventos',
  mixins: [errorhandler, swalerts],
  components:{
    Multiselect
  },
  data() {
    return {
      opciones:[],
      selected: '',
      txtDetalleDescripcion:'',
      txtDetalleFecha:'',
      txtDetalleCalendarioId:'',
      txtDetalleId:'',
      txtNombreEvento:'',
      eventoTipoFeriadoId:'',
      config: {
        locale: 'es',
        eventColor: 'rgb(226, 27, 0)',
        eventTextColor:'rgb(255, 255, 255)',
        firstDay:0,
        displayEventTime:false
      },
      events:[]

    }
  },
  methods: {
    handleSubmit(){
      this.$refs.modalRegistrarLicencia.hide()
    },
    limpiarCamposFormulario(){
      this.txtNombreEvento=''
      this.selected=''
    },
    //  Metodo para refrescar eventos del calendario
    refreshEvents() {
      this.$refs.calendar.$emit('refetch-events')
    },
    eventClick: function(eventObj) {
      this.abrirEditarEvento(eventObj);
    },
    next() {
      this.$refs.calendar.fireMethod('next')
    },
    changeView(view) {
      this.$refs.calendar.fireMethod('changeView', view)
    },
    dayClick: function(date) {
      this.abrirNuevoEvento(date);
    },

    abrirNuevoEvento(date) {
      this.txtDetalleDescripcion=''
      this.txtDetalleFecha = moment(date).format('YYYY-MM-DD')
      this.$root.$emit('bv::show::modal', 'modalNuevoEvento')
    },

    abrirEditarEvento(evento){
      this.txtDetalleDescripcion = evento.title,
      this.txtDetalleFecha = moment(evento.start).format('YYYY-MM-DD'),
      this.txtDetalleId = evento.id,
      this.txtDetalleCalendarioId = evento.calendarioFeriadoId
      this.$root.$emit('bv::show::modal', 'modalEdicion')
    },

    crearDetalleCalendario(){
      return DetalleCalendarioSvc.crear({
        CalendarioFeriado_Id: 5,
        Descripcion: this.txtDetalleDescripcion ,
        Fecha: this.txtDetalleFecha,
        TipoFeriado: this.selected.Id,
      })
    },
    actualizarDetalleCalendario(){
      return DetalleCalendarioSvc.cambiar({
        CalendarioFeriado_Id: this.txtDetalleCalendarioId,
        Descripcion: this.txtDetalleDescripcion ,
        Fecha: this.txtDetalleFecha,
        Id: this.txtDetalleId,
        TipoFeriado: this.selected.Id,
      })
    },
    removerDetalleCalendario(){
      return DetalleCalendarioSvc.eliminar({
        CalendarioFeriado_Id: this.txtDetalleCalendarioId,
        Descripcion: this.txtDetalleDescripcion ,
        Fecha: this.txtDetalleFecha,
        Id: this.txtDetalleId
      })
    },

    //  Metodo que nos permite crear un nuevo evento en el calendario
    crearNuevoDetalle() {
      this.crearDetalleCalendario().then(res => {
        this.$refs.modalNuevoEvento.hide();
        this.showSuccess("Evento registrado exitosamente");
      }).catch(e => {
        this.showError(e.response.data.status.mensaje);
      });
    },

    actualizarDetalle() {
      this.actualizarDetalleCalendario().then(res => {
        this.$refs.modalEdicion.hide();
        this.showSuccess("Evento actualizado exitosamente");
      }).catch(e => {
        this.showError(e.response.data.status.mensaje);
      });
    },
    removerDetalle() {
      this.removerDetalleCalendario().then(res => {
        this.$refs.modalEdicion.hide();
        this.showSuccess("Evento removido exitosamente");
      }).catch(e => {
        this.showError(e.response.data.status.mensaje);
      });
    },

    obtenerFeriados(){
      console.log("ObtenerFeriados");
      return DetalleCalendarioSvc.getLista({
        id:0
      });
    },

    obtenerTiposDeFeriados(){
      DetalleCalendarioSvc.getFormData()
        .then(response => {
          response.data.objeto.ListaTipoFeriado.Lista.forEach(s=>{
            this.opciones.push(s)
          })

        }).catch(e => {
          console.log("Error en: " + e);
        })
    },

    eventosCalendario(){
      this.obtenerFeriados()
      .then(response=>{
        response.data.rows.forEach(feriado=>{
          this.events.push({
            id:feriado.Id,
            calendarioFeriadoId:feriado.CalendarioFeriado_Id,
            title: feriado.Descripcion,
            start:feriado.Fecha
          })
          console.log("feriado: ",feriado);
        })

      }).catch(error=>{

      })
    }

  },
  created(){
    this.eventosCalendario();
    this.obtenerTiposDeFeriados();
  }
}
</script>
<style>
#calendar {
    max-width: 1000px;

    margin: 0 auto;
  }
.primer-fila{
  margin-top: 20px;
}
    @import '~fullcalendar/dist/fullcalendar.css';
</style>



// WEBPACK FOOTER //
// src/components/pages/configuraciones/Eventos.vue